
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PhotoResource,
} from '../models';
import {
    PhotoResourceFromJSON,
    PhotoResourceToJSON,
} from '../models';

export interface ChangePhotoRequest {
    file?: Blob;
}

/**
 * 
 */
export class AccountPhotoResourceApi extends runtime.BaseAPI {

    /**
          */
    async changePhotoRaw(requestParameters: ChangePhotoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PhotoResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<PhotoResource>({
            path: `/account/api/photo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=PhotoResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async changePhoto(requestParameters: ChangePhotoRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PhotoResource> {
        const response = await this.changePhotoRaw(requestParameters, initOverrides);
        return response._data;
    }

}
